import TransferPrescriptionsNotificationsContainer from './transfer-prescriptions-notifications-container';

export default TransferPrescriptionsNotificationsContainer;
